import { PillTrigger } from "./PillTrigger";
import { Trigger } from "./BellTrigger";
import useMetadataStore from "@/stores/metaDataStore";

interface ChatbotTriggerProps {
  setIsOpen: (isOpen: boolean) => void;
}

export const ChatbotTrigger = ({ setIsOpen }: ChatbotTriggerProps) => {
  const { offerMetadata } = useMetadataStore();

  if (offerMetadata) {
    return <PillTrigger setIsOpen={setIsOpen} />;
  }

  return <Trigger setIsOpen={setIsOpen} />;
};
